import React, { type FC, useState } from 'react'
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'


type OptionsProops = {
  title: string
  description: string
  onClick?: () => void
  current: boolean
  primary: boolean
}

export type BrandedWhitSupporetdTextProps = {
  title: string;
  options: OptionsProops[];
};

const publishingOptions = [
  { title: 'Published', description: 'TEXT ASD', current: true },
  { title: 'Draft', description: 'TEXT ASD II', current: false },
];

export const BrandedWhitSupporetdText: FC<BrandedWhitSupporetdTextProps> = ({
  title,
  options
}) => {
  const [selected, setSelected] = useState(publishingOptions[0]);

  return (
    <Listbox value={selected} onChange={setSelected}>
      <Label className="sr-only">Change published status</Label>
      <div className="relative">
        <div className="inline-flex divide-x divide-primary-700 rounded-md outline-none">
          <div className="inline-flex items-center gap-x-1.5 rounded-l-md bg-primary-600 px-3 py-2 text-white">
            <p className="text-sm font-semibold">{title}</p>
          </div>
          <ListboxButton className="inline-flex items-center rounded-l-none rounded-r-md bg-primary-600 p-2 outline-none hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-400">
            <span className="sr-only">Change published status</span>
            <ChevronDownIcon aria-hidden="true" className="size-5 text-white forced-colors:text-[Highlight]" />
          </ListboxButton>
        </div>

        <ListboxOptions
          transition
          className="absolute right-0 z-10 mt-2 w-[19rem] origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
        >
          {options.map((option) => (
            <ListboxOption
              key={option.title}
              value={option}
              onClick={option.onClick}
              className={`group cursor-default select-none p-2 text-sm text-gray-900 data-[focus]:text-white ${
                option.primary !== undefined
                  ? option.primary
                    ? 'data-[focus]:bg-primary-600'
                    : 'data-[focus]:bg-secondary-600'
                  : 'data-[focus]:bg-gray-600'
              }`}
              //className="group cursor-default select-none p-2 text-sm text-gray-900 data-[focus]:bg-primary-600 data-[focus]:text-white"
            >
              <div className="flex flex-col">
                <div className="flex justify-between">
                  <p className="font-normal group-data-[selected]:font-semibold">{option.title}</p>
                  <span className="text-primary-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                    <CheckIcon aria-hidden="true" className="size-5" />
                  </span>
                </div>
                <p className="mt-2 whitespace-normal text-gray-500 group-data-[focus]:text-gray-200">{option.description}</p>
              </div>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
  </Listbox>
  );
}